// deletes all matching entries for an array (but not objects and arrays)
const deleteEntries = (arr, entryToDelete) => {
  const newEntries = arr.filter((entry) => entry !== entryToDelete);
  return newEntries;
};


const isEquivalent = (arr1, arr2) => {
  // clones the arrays to prevent side affects
  const newArr1 = [
    ...arr1,
  ];
  const newArr2 = [
    ...arr2,
  ];

  // sorts the arrays and turns them to strings
  const arr1String = newArr1.sort().join(',');
  const arr2String = newArr2.sort().join(',');

  // compares strings
  if (arr1String === arr2String) {
    return true;
  }
  return false;
};


// converts the array into a set and then back to an array. Converting to a set removes duplications
const removeDuplications = (array) => Array.from(new Set(array));

// return a new array with item added or removed, depending on whether it is in the array
// used for toggling check boxes that are backed by an array of items
const toggleItem = (array, itemToToggle) => {
  const itemInArray = array.includes(itemToToggle);
  // if the item is within the array, return an array with the item removed
  if (itemInArray) {
    return array.filter((item) => item !== itemToToggle);
  }
  // otherwise add the item to the array
  return [...array, itemToToggle];
};

export {
  deleteEntries,
  isEquivalent,
  removeDuplications,
  toggleItem,
};
